import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import EFXCore3 from 'elem/ui-assets/icons/unregular/EFXCore3';
import EfLink from 'elem/ui/ef-link';
import EfSpec from 'elem/ui/ef-spec';
import EfTitle from 'elem/ui/ef-title';
import { useRouter } from 'next/router';
import { useProductStore } from './../../../ProductProvider';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('delta3series');
    const { locale = 'us' } = useRouter();
    const IS_NA_SITES = ['us', 'ca', 'br', 'mx'].includes(locale ?? '');
    const IS_EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'ph'].includes(locale ?? '');
    const { pageStatus } = useProductStore();

    const EU_STATUSB = pageStatus === 'statusB' && IS_EU_SITES;

    const A_STYLE = IS_NA_SITES || EU_STATUSB;

    const handleClick = () => {
        const target = document.getElementById('delta3-subsrcibe-eu') as HTMLDivElement;
        if (target) {
            target.scrollIntoView({
                top: 200,
                block: 'center',
                behavior: 'smooth',
            });
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_signup',
                button_name: t('EU1_btn'),
            });
        }
    };

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <div className={`info-box${A_STYLE ? ' na' : ''}`}>
                {A_STYLE && <EFXCore3 className="logo" />}
                {!A_STYLE && <EfTitle>{t('EU1_title')}</EfTitle>}
                {A_STYLE && <p className="desc">{t('EU1_desc')}</p>}
                {!A_STYLE && (
                    <button className="ef-link" onClick={handleClick}>
                        {t('EU1_btn')}
                    </button>
                )}
                {A_STYLE && !['br', 'mx', 'ph'].includes(locale) && (
                    <EfLink
                        className="ef-link"
                        href={`/${locale}/x-core-3`}
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'activity_preview',
                            button_name: EU_STATUSB ? t('EU1_btn2') : t('EU1_btn'),
                        }}
                    >
                        {EU_STATUSB ? t('EU1_btn2') : t('EU1_btn')}
                    </EfLink>
                )}
            </div>
            {!A_STYLE && <EfSpec className="spec-x" />}
        </div>
    );
}
